export const MessageModel = {
  id: null,
  text: "",
  startDate: "",
  expirationDate: "",
  amberAlert: false,
  priority: null,
  metroAreaId: "",
  latitude: "",
  longitude: "",
};

export const getAllMessages = async (
  activeOnly,
  includeIncidentMessages,
  setMessages,
  setAuthenticationChecked,
) => {
  var endpoint =
    "/admin/messages/all.json?activeOnly=" +
    activeOnly +
    "&includeIncidentMessages=" +
    includeIncidentMessages;

  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setMessages(res.data);
    });
    if (res.success === true) {
      setAuthenticationChecked("Success");
    } else if (
      res.error !== undefined &&
      res.error !== null &&
      res.error.code === "UNAUTHORIZED"
    ) {
      setAuthenticationChecked("UNAUTHORIZED");
    } else if (
      res.error !== undefined &&
      res.error !== null &&
      res.error.code === "FORBIDDEN"
    ) {
      setAuthenticationChecked("FORBIDDEN");
    }
    if (!res.ok) {
      if (res.status === 403) {
        setAuthenticationChecked("FORBIDDEN");
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {
    if (err.message.indexOf("401") > -1) {
      setAuthenticationChecked("UNAUTHORIZED");
    } else if (err.message.indexOf("403") > -1) {
      setAuthenticationChecked("FORBIDDEN");
    }
  }
};

export const getMessageLogs = async (messageId, setMessageLogs) => {
  var endpoint = "/admin/messagelogs/logs.json?id=" + messageId;
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: messageId }),
    });

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("adminUser");
        localStorage.removeItem("adminUser");
        localStorage.removeItem("authToken");
        window.dispatchEvent(new Event("adminLoginChange"));
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }

    res.json().then((res) => {
      setMessageLogs(res.data);
    });
  } catch (err) {
    if (err.message.indexOf("401") > -1 || err.message.indexOf("403") > -1) {
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("adminUser");
      localStorage.removeItem("adminUser");
      localStorage.removeItem("authToken");
      window.dispatchEvent(new Event("adminLoginChange"));
    }
  }
};

export const getAllMessageLogs = async (
  messageId,
  setMessageLogs,
  includeAutoGenerated = false,
) => {
  //   var filter = {
  //   // text: "important message",
  //   // operator: "admin",
  //   // priority: "HIGH",
  //   startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days ago
  //   endDate: new Date().toISOString(),
  //   id: null
  // };

  // var endpoint = "/admin/messagelogs/logs.json?id=" + messageId;
  var endpoint = "/admin/messagelogs/logs.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ includeAutoGenerated: includeAutoGenerated }),
    });

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("adminUser");
        localStorage.removeItem("adminUser");
        localStorage.removeItem("authToken");
        window.dispatchEvent(new Event("adminLoginChange"));
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }

    res.json().then((res) => {
      setMessageLogs(res.data);
    });
  } catch (err) {
    if (err.message.indexOf("401") > -1 || err.message.indexOf("403") > -1) {
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("adminUser");
      localStorage.removeItem("adminUser");
      localStorage.removeItem("authToken");
      window.dispatchEvent(new Event("adminLoginChange"));
    }
  }
};

export const getMessage = async (messageId, setMessage) => {
  const endpoint = "/admin/messages/" + messageId + "/motd.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("adminUser");
        localStorage.removeItem("adminUser");
        localStorage.removeItem("authToken");
        window.dispatchEvent(new Event("adminLoginChange"));
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }

    res.json().then((res) => {
      setMessage(res.data);
    });
  } catch (err) {
    if (err.message.indexOf("401") > -1 || err.message.indexOf("403") > -1) {
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("adminUser");
      localStorage.removeItem("adminUser");
      localStorage.removeItem("authToken");
      window.dispatchEvent(new Event("adminLoginChange"));
    }
  }
};

export const getPriorities = async (setPriorities) => {
  const endpoint = "/admin/messages/priorities.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("adminUser");
        localStorage.removeItem("adminUser");
        localStorage.removeItem("authToken");
        window.dispatchEvent(new Event("adminLoginChange"));
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }

    res.json().then((res) => {
      setPriorities(res.data);
    });
  } catch (err) {
    if (err.message.indexOf("401") > -1 || err.message.indexOf("403") > -1) {
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("adminUser");
      localStorage.removeItem("adminUser");
      localStorage.removeItem("authToken");
      window.dispatchEvent(new Event("adminLoginChange"));
    }
  }
};

export const createMessage = async (message) => {
  const endpoint = "/admin/messages/motd.json";
  message.creationDate = new Date().toISOString();
  message.lastUpdate = new Date().toISOString();
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(message),
    });

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("adminUser");
        localStorage.removeItem("adminUser");
        localStorage.removeItem("authToken");
        window.dispatchEvent(new Event("adminLoginChange"));
        alert("Session expired. Please login again.");
        return;
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }

    res.json().then((res) => {
      if (res.success) alert("New Message is Created");
      else alert("Message Creation went wrong" + res.error.message);
    });
  } catch (err) {
    if (err.message.indexOf("401") > -1 || err.message.indexOf("403") > -1) {
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("adminUser");
      localStorage.removeItem("adminUser");
      localStorage.removeItem("authToken");
      window.dispatchEvent(new Event("adminLoginChange"));
      alert("Session expired. Please login again.");
    } else {
      alert("Something went wrong.." + err);
    }
  }
};

export const saveMessage = async (message) => {
  const endpoint = "/admin/messages/" + message.id + "/motd.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(message),
    });

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("adminUser");
        localStorage.removeItem("adminUser");
        localStorage.removeItem("authToken");
        window.dispatchEvent(new Event("adminLoginChange"));
        alert("Session expired. Please login again.");
        return;
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }

    res.json().then((res) => {
      if (res.success) alert("Message has been Updated Successfully.");
      else alert("Message Update went wrong." + res.error.message);
    });
  } catch (err) {
    if (err.message.indexOf("401") > -1 || err.message.indexOf("403") > -1) {
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("adminUser");
      localStorage.removeItem("adminUser");
      localStorage.removeItem("authToken");
      window.dispatchEvent(new Event("adminLoginChange"));
      alert("Session expired. Please login again.");
    } else {
      alert("Something went wrong..." + err);
    }
  }
};

export const deleteMessage = async (message) => {
  const endpoint = "/admin/messages/" + message.id + "/motd.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "DELETE",
    });

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("adminUser");
        localStorage.removeItem("adminUser");
        localStorage.removeItem("authToken");
        window.dispatchEvent(new Event("adminLoginChange"));
        alert("Session expired. Please login again.");
        return;
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }

    res.json().then((res) => {
      if (res.success) alert("Message has been Deleted Successfully.");
      else alert("Message deletion went wrong." + res.error.message);
    });
  } catch (err) {
    if (err.message.indexOf("401") > -1 || err.message.indexOf("403") > -1) {
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("adminUser");
      localStorage.removeItem("adminUser");
      localStorage.removeItem("authToken");
      window.dispatchEvent(new Event("adminLoginChange"));
      alert("Session expired. Please login again.");
    } else {
      alert("Something went wrong-->" + err);
    }
  }
};
